// Shared validation + small utilities for the careers wizards.

export const isEmpty = (v) => v === undefined || v === null || v.toString().trim() === "";
export const isLettersOnly = (v) => /^[a-zA-Z\s]*$/.test(v);
export const isValidDotsHyphens = (v) => /^[a-zA-Z\s.-]*$/.test(v);
export const isMaxDigits = (v, max = 2) => new RegExp(`^\\d{0,${max}}$`).test(v);
export const isValidNumber = (v, maxDigits = 5) => new RegExp(`^\\d{0,${maxDigits}}$`).test(v);

export const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const mobileRe = /^[6-9]\d{9}$/;

// Reference id: PREFIX + yyMMddHHmmss
export const makeRefId = (prefix = "") => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${prefix}${String(d.getFullYear()).slice(-2)}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
};

// Date bounds for DOB inputs (today .. 60 years ago)
export const dateBounds = () => {
  const today = new Date();
  const max = today.toISOString().split("T")[0];
  const min = new Date();
  min.setFullYear(today.getFullYear() - 60);
  return { max, min: min.toISOString().split("T")[0], currentYear: today.getFullYear() };
};

// Validate a resume File against accept + max size (kB). Returns error string or "".
export const validateResume = (file, maxKB = 200) => {
  if (!file) return "Resume is required";
  const f = file instanceof File ? file : null;
  if (!f) return "Invalid file";
  const ext = f.name.toLowerCase().split(".").pop();
  if (ext !== "pdf") return "Only PDF allowed";
  if (f.size > maxKB * 1024) return `File size must be below ${maxKB} kB`;
  return "";
};
